import { CustomizeInsight } from './customize.insight.component';
import { LegendInsight } from './legend.insight.component';
import { PersistInsight } from './persist.insight.component';
import { SelectedVisualItemInsight } from './selected-visual-item.insight.component';
import { SelectionSummaryInsight } from './selection-summary.insight.component';

export default {
    'cmps-insight-persist': PersistInsight,
    'cmps-insight-selected-visual-item': SelectedVisualItemInsight,
    'cmps-insight-legend': LegendInsight,
    'cmps-insight-selection-summary': SelectionSummaryInsight,
    'cmps-insight-customize': CustomizeInsight,
};
